import {
    DataDimension,
    DataSource,
    Parameters,
    ReportType,
} from '../../backend';
import { ParameterLabelsView } from '../model/parameter-labels-view.model';

import { formatCacheDate } from './format-cache-date.function';
import { formatRawDate } from './format-raw-date.function';

export function createParamLabelsView(bp: Parameters): ParameterLabelsView {
    const vpl: ParameterLabelsView = {};

    switch (bp.dataSource) {
        case DataSource.Cache: {
            vpl.dataSourceLabel = 'Cached';

            vpl.periodTypeValueLabel = bp.periodType?.text;

            vpl.dateRangeValueLabel = formatCacheDate(
                bp.periodType?.id,
                bp.startDate,
                bp.endDate,
            );

            break;
        }
        case DataSource.Raw:
            vpl.dataSourceLabel = 'Custom';

            vpl.dateRangeValueLabel = formatRawDate(bp.startDate, bp.endDate);

            break;
    }

    switch (bp.reportType) {
        case ReportType.Role:
            vpl.reportTypeLabel = 'Role';
            vpl.reportTypeValueLabel = bp.roles?.[0]?.fullName;

            vpl.dataDimensionALabel = 'Site';
            vpl.dataDimensionAValueLabel =
                bp.sites?.[0]?.id === -1 ? 'All' : bp.sites?.[0]?.fullName;

            switch (bp.dataDimension) {
                case DataDimension.Queue:
                    vpl.dataDimensionBLabel = 'Queue';
                    vpl.dataDimensionBValueLabel =
                        bp.queues?.[0]?.id === -1
                            ? 'All'
                            : bp?.queues?.[0]?.fullName;
                    break;
                case DataDimension.SuperGroup:
                    vpl.dataDimensionBLabel = 'SuperGroup';
                    vpl.dataDimensionBValueLabel =
                        bp?.superGroups?.[0]?.fullName;
                    break;
            }
            break;
        case ReportType.Team:
            vpl.reportTypeLabel = 'Team';
            if (bp.teams?.[0]?.id != null) {
                vpl.reportTypeValueLabel = `${bp.teams?.[0]?.firstName ?? ''} ${
                    bp.teams?.[0]?.lastName ?? ''
                }`.trim();
            }

            vpl.dataDimensionBLabel = 'Queue';
            vpl.dataDimensionBValueLabel =
                bp.queues?.[0]?.id === -1 ? 'All' : bp.queues?.[0]?.fullName;
            break;
        case ReportType.Individual:
            vpl.reportTypeLabel = 'Individual';
            if (bp.individuals?.[0]?.id != null) {
                vpl.reportTypeValueLabel = `${
                    bp.individuals?.[0]?.firstName ?? ''
                } ${bp.individuals?.[0]?.lastName ?? ''}`.trim();
            }

            vpl.dataDimensionBLabel = 'Queue';
            vpl.dataDimensionBValueLabel =
                bp.queues?.[0]?.id === -1 ? 'All' : bp.queues?.[0]?.fullName;
            break;
    }

    vpl.metricValueLabel = bp.metrics
        ?.map((e) => e.fullName?.trim())
        ?.filter((e) => e != null)
        ?.join(', ');

    return vpl;
}
